export default {

    // 用户登陆
    login: "/security/login",
    // 绑定邀请码
    binding: "/security/checkUser",

}


// WEBPACK FOOTER //
// ./src/http/api.js